import classNames from "classnames";
import { ReactNode } from "react";
import styles from "./styles.module.scss";

interface Action<T> {
  key: React.Key;
  label?: string;
  icon?: ReactNode;
  onClick: (record: T) => void;
}

interface ActionsProps<T> {
  record: T;
  actions: Action<T>[];
  classname?: string;
}

export const Actions = <T,>({
  record,
  actions,
  classname,
}: ActionsProps<T>) => {
  return (
    <div className={classNames(styles.actions, classname)}>
      {actions.map((action) => (
        <button key={action.key} onClick={() => action.onClick(record)}>
          {action.icon && <span className={styles.icon}>{action.icon}</span>}
          {action.label && <span className={styles.label}>{action.label}</span>}
        </button>
      ))}
    </div>
  );
};
